<template>
  <div class="category-page">
    <div class="category-layout">
      <div class="category-panel">
        <div class="panel-head">
          <strong>产品大项</strong>
          <a-button type="primary" size="small" icon="plus" @click="handleCreateCategory">新增大项</a-button>
        </div>
        <a-spin :spinning="loading">
          <div
            v-for="item in categories"
            :key="item.id"
            class="category-item"
            :class="{ active: selectedCategory && selectedCategory.id === item.id }"
            @click="selectCategory(item)"
          >
            <span>{{ item.name }}</span>
            <span class="item-actions" @click.stop>
              <a @click="handleEditCategory(item)">编辑</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确定删除该产品大项吗？" @confirm="handleDelete(item)">
                <a class="danger">删除</a>
              </a-popconfirm>
            </span>
          </div>
          <a-empty v-if="!categories.length" description="暂无分类" />
        </a-spin>
      </div>

      <div class="category-panel sub-panel">
        <div class="panel-head">
          <strong>{{ selectedCategory ? selectedCategory.name + ' / 产品种类' : '产品种类' }}</strong>
          <a-button type="primary" size="small" icon="plus" :disabled="!selectedCategory" @click="handleCreateSubCategory">新增种类</a-button>
        </div>
        <a-table
          :columns="columns"
          :data-source="subCategories"
          rowKey="id"
          :pagination="false"
          :locale="{ emptyText: selectedCategory ? '暂无产品种类' : '请先选择左侧产品大项' }"
        >
          <span slot="status" slot-scope="text">
            <a-tag :color="text === 1 ? 'green' : 'orange'">{{ text === 1 ? '启用' : '停用' }}</a-tag>
          </span>
          <span slot="action" slot-scope="text, record">
            <a @click="handleEditSubCategory(record)">编辑</a>
            <a-divider type="vertical" />
            <a-popconfirm title="确定删除该产品种类吗？" @confirm="handleDelete(record)">
              <a class="danger">删除</a>
            </a-popconfirm>
          </span>
        </a-table>
      </div>
    </div>

    <a-modal v-model="visible" :title="form.parentId === 0 ? '产品大项信息' : '产品种类信息'" @ok="handleOk">
      <a-form-model :model="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
        <a-form-model-item label="所属大项" v-if="form.parentId !== 0">
          <a-input :value="selectedCategory ? selectedCategory.name : ''" disabled />
        </a-form-model-item>
        <a-form-model-item label="名称">
          <a-input v-model="form.name" placeholder="请输入名称" />
        </a-form-model-item>
        <a-form-model-item label="排序">
          <a-input-number v-model="form.sortOrder" :min="0" style="width:100%;" />
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-switch :checked="form.status === 1" @change="val => form.status = val ? 1 : 0" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { getProductCategoryTree, saveProductCategory, deleteProductCategory } from '@/api'

export default {
  data() {
    return {
      loading: false,
      visible: false,
      categories: [],
      selectedCategory: null,
      form: {},
      columns: [
        { title: 'ID', dataIndex: 'id', width: 80 },
        { title: '产品种类名称', dataIndex: 'name' },
        { title: '排序', dataIndex: 'sortOrder', width: 100 },
        { title: '状态', dataIndex: 'status', width: 110, scopedSlots: { customRender: 'status' } },
        { title: '操作', key: 'action', width: 150, scopedSlots: { customRender: 'action' } }
      ]
    }
  },
  computed: {
    subCategories() {
      return this.selectedCategory && this.selectedCategory.children ? this.selectedCategory.children : []
    }
  },
  created() {
    this.loadTree()
  },
  methods: {
    loadTree() {
      this.loading = true
      getProductCategoryTree().then(res => {
        this.categories = res.data || []
        if (this.selectedCategory) {
          this.selectedCategory = this.categories.find(item => item.id === this.selectedCategory.id) || this.categories[0] || null
        } else {
          this.selectedCategory = this.categories[0] || null
        }
      }).finally(() => {
        this.loading = false
      })
    },
    selectCategory(item) {
      this.selectedCategory = item
    },
    handleCreateCategory() {
      this.form = { parentId: 0, name: '', sortOrder: 0, status: 1 }
      this.visible = true
    },
    handleEditCategory(item) {
      this.form = { ...item, parentId: 0 }
      this.visible = true
    },
    handleCreateSubCategory() {
      if (!this.selectedCategory) return
      this.form = { parentId: this.selectedCategory.id, name: '', sortOrder: 0, status: 1 }
      this.visible = true
    },
    handleEditSubCategory(item) {
      this.form = { ...item, parentId: this.selectedCategory.id }
      this.visible = true
    },
    handleOk() {
      saveProductCategory(this.form).then(() => {
        this.$message.success('保存成功')
        this.visible = false
        this.loadTree()
      })
    },
    handleDelete(record) {
      deleteProductCategory({ id: record.id }).then(() => {
        this.$message.success('删除成功')
        this.loadTree()
      })
    }
  }
}
</script>

<style scoped>
.category-page {
  padding: 20px;
  background: #f0f2f5;
  min-height: calc(100vh - 96px);
}
.category-layout {
  display: grid;
  grid-template-columns: 340px 1fr;
  gap: 16px;
}
.category-panel {
  background: #fff;
  padding: 16px;
}
.panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.category-item {
  padding: 12px;
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  align-items: center;
}
.category-item.active {
  background: #e6f7ff;
}
.item-actions {
  margin-left: auto;
}
.danger {
  color: #f5222d;
}
@media (max-width: 900px) {
  .category-layout {
    grid-template-columns: 1fr;
  }
}
</style>
